module.exports = __webpack_public_path__ + "static/media/icon_menu_transform.d49b3aab.svg";